import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
export var hasUrlParameter = function hasUrlParameter(name, url) {
  var cleanedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(cleanedName, "=([^&#]*)"));
  var results = regex.exec(url);
  return results !== null;
};